module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-lg@2x.ce091f59.jpg";